export const contextHelpIds = {
    viewer: 'c_viewer',

    mtconsole: {
        tenant: 'c_tenants',
        databaseServer: 'c_db_server'
    },

    admin: {
        dashboard: 'c_dashboard',
        authentication: 'c_authentication',
        project: 'c_projects',
        connection: 'c_connections',
        insightUser: 'c_users',
        userMapping: 'c_usermapping',
        role: 'c_rolesgeneral',
        userFilter: 'c_userfilters',
        filterGroup: 't_createfiltergroups',
        alert: 't_viewalerts',
        distribution: 't_customizereportdistribution',
        calendar: 'c_calendars',
        financialYear: 't_financial_year',
        logs: 'c_logstatistics',
        options: 'c_options',
        license: 't_licensemanager',
        sqlFunction: 't_definecustomsqlfunctions',
        externalProgram: 't_externalprogram'
    },

    themeManager: {
        theme: 'c_themesintro',
        dateFormat: 't_dateformats',
        format: 'c_formats',
        tooltipFormat: 'c_tooltip_formatsintro',
        labelFormat: 'c_labelformats',
        viewLayout: 'c_view_layouts',
        fontFamilies: 't_use_font_families'
    },

    dataLoader: {
        executionPlans: 'c_execution_plans_tab',
        loadConsole: 'c_load_console_tab',
        recordDates: 'c_record_dates',
        schedulerLogs: 'c_scheduler_log'
    },

    studio: {
        guide: 'c_guide',
        dataSource: 'c_datasources',
        record: 'c_records',
        rModel: 't_rmodels',
        rFunction: 't_rfunctions',
        metricPool: 'c_standardmetric',
        derivedMetric: 'c_deivedmetric',
        processMetric: 'c_derived_metric',
        olapDocument: 't_analyses_services_metric',
        metricGroup: 'c_metricgroups',
        regressionMetric: 'c_regressionmetric',
        translationTable: 'c_translation_tables',
        view: 'c_views',
        dashboardDesigner: 'c_welcome',
        basicPdfReport: 't_newbasic_reports',
        advancedPdfReport: 't_advanced_reports',
        cacheReport: 'c_cache_reports',
        excelReport: 't_grid_extractors',
        fileProviderTemplate: 't_createtemplate',
        fileProviderBatch: 't_createabatch',
        fileProviderServer: 't_configureftpdownloader',
        fileProviderTask: 't_configureftpdownloader',
        fileProviderFTPLog: 't_viewftplogs',
        fileProviderJobLog: 't_viewparsinglogs',
        executionPlan: 'c_executionplans',
        process: 'c_processes',
        dataload: 't_loaddata',
        parameter: 'c_parameters',
        constant: 'c_constants',
        accelerator: 'c_accelerators',
        geoMap: 'c_insightgeomaps',
        webService: 't_remoteservices',
        audit: 'c_audit',
        testProject: 'c_testProject',
        testSession: 't_test_sessions',
        runManualJob: 't_run_job',

        additionalRecordConfiguration: 'c_additional_record_configurations'
    }
};
